import React, { useEffect, useState } from "react";
import Fade from "react-reveal/Fade";
import ProjectCard from "../Items/ProjectCard";
import projectList from "../Items/ProjectList";
import Button from "../Items/Button";

const skills = [
  {
    id: 1,
    skill: "ReactJS",
  },
  {
    id: 2,
    skill: "NextJS",
  },
  {
    id: 3,
    skill: "Vanilla JS",
  },
  {
    id: 4,
    skill: "Others",
  },
];

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("ReactJS");
  console.log(filter);

  const onButtonClick = (text) => {
    if (text === "Others") {
      setFilter("Unity");
    } else setFilter(text);
  };

  const buttons = skills.map((skill) => {
    return (
      <Button
        key={skill.id}
        onClickHandler={() => {
          return onButtonClick(skill.skill);
        }}
        text={skill.skill}
      ></Button>
    );
  });

  useEffect(() => {
    const filteredProjects = projectList.filter((item) => {
      return item.tech.includes(filter);
    });

    setProjects(filteredProjects);

    console.log(filteredProjects);
  }, [filter]);

  return (
    <Fade>
      <div name="projects" className="w-full h-full">
        <div className="max-w-[1100px] p-4 mx-auto flex flex-col justify-center w-full h-full text-gray-300">
          <div className="pb-8">
            <p className="text-4xl font-bold border-b-8 border-pink-600 pb-4">
              Projects
            </p>
            <p className="py-6 font-bold">// Check out some of my work</p>
          </div>
          <div className="md:flex md:flex-row md:justify-between mb-10 grid grid-cols-2 gap-4 ">
            {buttons}
          </div>
          <div className="cards">
            {projects.map((item) => {
              return <ProjectCard {...item} key={item.id}></ProjectCard>;
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Projects;
